import { FaEye, FaEyeSlash } from "react-icons/fa";

export const PasswordInput = ({ label, value, onChange, showPassword, toggleShowPassword, placeholder }) => (
    <div>
        <label className="block text-sm font-medium text-gray-300 mb-2">{label}</label>
        <div className="relative">
            <input
                type={showPassword ? 'text' : 'password'}
                value={value}
                onChange={onChange}
                className="w-full bg-gray-900 border border-gray-700 rounded-lg px-4 py-3 text-white pr-10"
                placeholder={placeholder}
            />
            <button
                type="button"
                className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-white"
                onClick={toggleShowPassword}
            >
                {showPassword ? <FaEyeSlash className="w-5 h-5" /> : <FaEye className="w-5 h-5" />}
            </button>
        </div>
    </div>
);